import Homepage from '@/components/routes/homepage';
export default Homepage;
